<section class="form">
	<h2>{{ "footer.legalNotices" | translate }}</h2>
	<br />
	<div
		class="box text-page"
		[innerHTML]="'legal-notes.html-full' | translate | safeHtml"
	></div>
</section>